import { gql, useMutation } from '@apollo/client'

export const USER_SETTINGS_UPDATE = gql`
  mutation UserSettingsUpdate($locale: String!) {
    userSettingsUpdate(
      input: { locale: $locale, clientMutationId: "user-settings-update" }
    ) {
      user {
        id
        locale
      }
      errors
    }
  }
`

interface IUserSettingsUpdateResult {
  userSettingsUpdate: {
    user: { id: number; locale: string | null } | null
    errors: string[]
  }
}

export const useUserSettingsUpdate = () => {
  const [updateSettings, { loading, error }] =
    useMutation<IUserSettingsUpdateResult>(USER_SETTINGS_UPDATE, {
      refetchQueries: ['getProfile'],
    })

  const handleUpdateSettings = async (locale: string) => {
    const response = await updateSettings({ variables: { locale } })
    return response.data?.userSettingsUpdate
  }

  return { handleUpdateSettings, loading, error }
}
